import React from 'react'
import IconButton from '@/components/ui/Buttons/IconButton'
import { ReactComponent as HistoryIcon } from '@/assets/icons/history.svg'

export type Props = {
  onClick?: () => void
}

const HistoryButton = ({ onClick }: Props) => {
  return (
    <IconButton onClick={onClick} color={'neutral'}>
      <HistoryIcon />
    </IconButton>
  )
}

export default HistoryButton
